import classNames from 'classnames';
import React from 'react';
import { HasClassName } from '../component-utils';
import DropdownButton from './DropdownButton';
import './SplitButton.scss';

interface Props extends HasClassName {
  activeClassName?: string
  separatorClassName?: string
  title?: string
  items: React.ReactNode
  onClick?(): void
}

export default function SplitButton({ className, activeClassName, separatorClassName, items, children, onClick, title }: React.PropsWithChildren<Props>) {
  return <div className={classNames('SplitButton', className)}>
    <button onClick={onClick} title={title}>
      {children}
    </button>
    <div className={classNames('separator', separatorClassName)} />
    <DropdownButton className='dropdown' items={items} activeClassName={activeClassName} />
  </div>
}
